
import { Form, Select } from 'antd';
import React from 'react'

const SelectUC = (props) => {
    const { Option } = Select;
    const {
        showSearch = false,
        defaultValue,
        label,
        optionValues,
        placeholder = 'กรุณาเลือก' + label,
        showLabel = true,
        onChange,
        values,
        maxLength,
        suffix,
        required,
        disabled,
        hidden,
        name,
        isCustomError = false,
        labelError = null,
        showPlaceholder = true,
        ...prop } = props;
    return (
        <>
            <Form.Item
                label={showLabel ? (label + ' :') : ''}
                rules={required ? [{ required: true, message: 'กรุณาเลือก ' + label }] : ''}
                validateStatus={(isCustomError && required) ? 'error' : undefined}
                help={(isCustomError && required) ? labelError : null}
                initialValue={values ? values : undefined}
                name={name}
            >
                <Select
                    className={'select-rc'}
                    showSearch={showSearch}
                    onChange={onChange}
                    disabled={disabled}
                    placeholder={showPlaceholder ? placeholder : ''}
                    optionFilterProp="children"
                    {...prop}
                >
                    {
                        optionValues && optionValues.length > 0 ?
                            optionValues.map((value, index) => {
                                return <Option key={index} value={value.value}>{value.label}</Option>
                            })
                            : ''
                    }
                </Select>
            </Form.Item>
        </>
    )
}

export default SelectUC